import { Form, Spin } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FirmUserForm from "./FirmUserForm";
import useCommonsService from "../../../services/useCommonsService";
import useFirmService from "../../../services/useFirmService";
import useAuth from "../../../hooks/useAuth";

const AddFirmUser = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const { firmAuth } = useAuth();
  const { useCreateFirmUser } = useFirmService();
  const { mutate: createFirmUser } = useCreateFirmUser();
  const navigate = useNavigate();

  const addFirmUser = async (values) => {
    const requestBody = {
      ...values,
      countryCode: 90,
      firmId: firmAuth.user.firm.id,
    };

    createFirmUser(requestBody);
  };

  return (
    <div>
      <FirmUserForm form={form} onFinish={addFirmUser} />

      <Spin spinning={isLoading} fullscreen />
    </div>
  );
};

export default AddFirmUser;
